import { render, staticRenderFns } from "./ReportNavision.vue?vue&type=template&id=59708c52&"
import script from "./ReportNavision.vue?vue&type=script&lang=js&"
export * from "./ReportNavision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports